import React  from 'react';
import { Modal } from "antd";
const ViewerFrame = ({ visible, source, title, onCancel }) => {
  const close = () => {
    onCancel();
  };
  return (
    <React.Fragment>
    <Modal 
      open={visible} 
      width={850}
      centered
      header={null}
      footer={null}
      onCancel={close}
    >
            <h3 style={{ fontSize:"14pt",color:'darkgreen' }} className="mb-2">{`${title}`}</h3>
                <div className="mt-4 text-center">
                  <iframe
                    title={title}
                    src={source}
                    width="800px"
                    height="1200px"
                  />
                </div> 
    </Modal>
    </React.Fragment>
  );
};

export default ViewerFrame;
